module.exports = __webpack_public_path__ + "img/C05TechCretanBowmanChampion_ua.b255657e.webp";